import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { PLATFORM_ENUM_OPTIONS } from "constants/coupons";
import { PLATFORM_META } from "constants/platformUi";

import packageStyles from "../PackageSelector/PackageSelector.module.scss";
import styles from "./PlatformListView.module.scss";

const PlatformListView = ({
  selectAll = false,
  selectedIds = [],
  viewMode = false,
}) => {
  const selectedPlatforms = selectAll
    ? PLATFORM_ENUM_OPTIONS
    : PLATFORM_ENUM_OPTIONS.filter((platform) =>
        selectedIds.includes(platform.platformId)
      );

  if (selectAll) {
    return (
      <div className={styles.container}>
        <div className={styles.infoBanner}>
          <InfoOutlinedIcon fontSize="small" />
          <span>
            {viewMode
              ? `This coupon applies to all platforms (${PLATFORM_ENUM_OPTIONS.length} total).`
              : `Coupon is applicable to all platforms (${PLATFORM_ENUM_OPTIONS.length} total).`}
          </span>
        </div>

        <div className={packageStyles.browsePane}>
          <div className={packageStyles.paneHeader}>
            <h3>{viewMode ? "Applicable Platforms" : "All Platforms"}</h3>
            <span>{selectedPlatforms.length} total</span>
          </div>
          <PlatformBrowseList
            platforms={PLATFORM_ENUM_OPTIONS}
            selectedIds={PLATFORM_ENUM_OPTIONS.map((p) => p.platformId)}
            readOnly
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={packageStyles.dualPane}>
        <div className={packageStyles.browsePane}>
          <div className={packageStyles.paneHeader}>
            <h3>Browse Platforms</h3>
            <span>{PLATFORM_ENUM_OPTIONS.length} available</span>
          </div>
          <PlatformBrowseList
            platforms={PLATFORM_ENUM_OPTIONS}
            selectedIds={selectedIds}
            readOnly
          />
        </div>

        <div className={packageStyles.selectedPane}>
          <div className={packageStyles.paneHeader}>
            <h3>
              {viewMode
                ? `Applicable Platforms (${selectedPlatforms.length})`
                : `Selected Platforms (${selectedPlatforms.length})`}
            </h3>
          </div>
          <div className={packageStyles.selectedList}>
            {selectedPlatforms.length === 0 ? (
              <p className={packageStyles.stateText}>
                {viewMode
                  ? "No applicable platforms found."
                  : "No platforms selected."}
              </p>
            ) : (
              selectedPlatforms.map((platform) => {
                const meta = PLATFORM_META[platform.key] ?? {};
                return (
                  <div
                    key={platform.platformId}
                    className={packageStyles.selectedItem}
                  >
                    <div>
                      <span className={packageStyles.selectedName}>
                        {platform.label}
                      </span>
                      {meta.description && (
                        <span className={packageStyles.selectedMeta}>
                          {meta.description}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const PlatformBrowseList = ({ platforms, selectedIds, readOnly = false }) => (
  <div className={styles.browseList}>
    {platforms.map((platform) => {
      const meta = PLATFORM_META[platform.key] ?? {};
      const PlatformIcon = meta.icon;
      const isSelected = selectedIds.includes(platform.platformId);

      return (
        <div
          key={platform.key}
          className={`${styles.platformCard} ${
            isSelected ? styles.platformCardSelected : ""
          } ${readOnly ? styles.platformCardReadOnly : ""}`}
        >
          <div className={styles.platformCardContent}>
            <div className={styles.platformCardTitle}>
              {PlatformIcon && (
                <PlatformIcon className={styles.platformBoxIcon} />
              )}
              <span>{platform.label}</span>
            </div>
            {meta.description && (
              <span className={styles.platformBoxDescription}>
                {meta.description}
              </span>
            )}
          </div>
        </div>
      );
    })}
  </div>
);

export default PlatformListView;
